<template>
  <div>
    <!--顶部标题菜单-->
    <div class = "header">
      <p class = "h_title">{{txtLang[curLang]['task']}}</p>
      <div class = "h_btn" >
        <a :class = "noticeNum > 0 ? 'redPoint' : ''" @click="hideSide" href = "javascript:void(0)">
          <img src = "../../static/image/icon_menu.png"/>
        </a>
      </div>
    </div>

    <!--个人信息-->
    <div class = "person">
      <div class = "p_box flex flex-align-center">
        <div class = "pb_left">
          <img src = "../../static/image/icon_coin.png" />
          <p>{{txtLang[curLang]['mCoin']}}</p>
        </div>
        <div v-if = "ifLogin" class = "pb_num flex-1">
          <p :class = "aniCoinSH ? 'p_coin' : ''">{{moneyStr(curCoin)}}<b>{{aniCoinNum}}</b></p>
        </div>
        <div v-else class = "pb_loginBtn flex-1">
          <a @click = "toLoginFn" href = "javascript:void(0);">{{txtLang[curLang]['login']}}</a>
        </div>
        <div class = "pb_btn">
          <router-link :to="{name: 'taskRule'}">
            {{txtLang[curLang]['taskRule']}}
          </router-link>
        </div>
      </div>
    </div>

    <div class = "body">
      <div class = "b_box" v-if = "JSON.stringify(info.sign_in_config) != '[]'">
        <div class = "b_l">
          <ul class = "signBox">
            <li :class = "signArr[0] == 0 ? '' : (signArr[0] == 1 ? 'ing' : 'on')">
              <div class = "s_top">
                <div class = "st_num">{{info.sign_in_config.day_one}}</div>
              </div>
              <div class = "s_txt">{{signArr[0] == 0 ? txtLang[curLang].firstDay : (signArr[0] == 1 ? txtLang[curLang].firstDay : txtLang[curLang].done)}}</div>
            </li>
            <li :class = "signArr[1] == 0 ? '' : (signArr[1] == 1 ? 'ing' : 'on')">
              <div class = "s_top">
                <div class = "st_num">{{info.sign_in_config.day_two}}</div>
              </div>
              <div class = "s_txt">{{signArr[1] == 0 ? txtLang[curLang].secondDay : (signArr[1] == 1 ? txtLang[curLang].secondDay : txtLang[curLang].done)}}</div>
            </li>
            <li class = "mrN" :class = "signArr[2] == 0 ? '' : (signArr[2] == 1 ? 'ing' : 'on')">
              <div class = "s_top">
                <div class = "st_num">{{info.sign_in_config.day_three}}</div>
              </div>
              <div class = "s_txt">{{signArr[2] == 0 ? txtLang[curLang].thirdDay : (signArr[2] == 1 ? txtLang[curLang].thirdDay : txtLang[curLang].done)}}</div>
            </li>
          </ul>
        </div>
        <a @click = "toSign" :class = "info.user.is_sign != 0 ? 'b_r_on' : ''" class = "b_r" href = "javascript:void(0);">{{txtLang[curLang].signIn}}</a>
      </div>
      <div class = "b_list" v-if = "JSON.stringify(info.today) != '[]'">
        <div class = "bl_title">{{txtLang[curLang]['todayTask']}}</div>
        <ul class = "bl_list">
          <li>
            <div class = "bl_top">
              <p>{{info.today.title}} ({{info.user.today_bet_num}}/{{info.today.bet_num}})</p>
              <span>+{{info.today.coins}}</span>
            </div>
            <div class = "flex flex-align-center" :class = "parseInt(info.user.today_bet_num) >= parseInt(info.today.bet_num) ? 'bl_bg' : ''">
              <div class = "flex-1">
                <div v-if = "parseInt(info.user.today_bet_num) < parseInt(info.today.bet_num)" class = "bl_progress"><div :style = "{width:info.user.today_bet_num/info.today.bet_num*100 + '%'}"></div></div>
                <div v-else class = "bl_tip">{{txtLang[curLang].taskFinishTip}}</div>
              </div>
              <div class = "bl_btn">
                <a @click = "toGuess" href = "javascript:void(0)">{{txtLang[curLang]['toBet']}}</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <None v-if = "JSON.stringify(info.sign_in_config) == '[]' && JSON.stringify(info.today) == '[]'" :noData="txtLang[langName]['noData']"/> 
    </div>

    <!--alert层-->
    <Alert ref="Alert" :txt = "alertTip"/>

    <!--侧边栏-->
    <sideBar ref="Model"></sideBar>

    <LoadingBox v-show = "loadSh"/> 

     <!--签到成功弹出层-->
    <div class = "signPop" v-show = "signSh">
      <div class = "s_box">
        <img src = '../../static/image/signSuccess.png' />
        <div class = "sb_p1">{{txtLang[curLang].signSuccess}}</div>
        <div class = "sb_p2">+{{moneyStr(signNum)}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Lx from './common/Lx'
import sideBar from './sideBar'
import Alert from './common/Alert'
import qs from 'qs'
import LoadingBox from './common/Loading'
import None from './common/None'

export default {
  name: 'HelloWorld',
  components:{
    Lx,
    sideBar,
    Alert,
    LoadingBox,
    None
  },
  data () {
    return {
      signNum:0,
      signSh:false,
      loadSh:false,//loading
      alertTip:'',//alert文本
      ifLogin:false,//是否登录
      curCoin:0,//当前M币
      canBet:1,//是否能投注，1正常2封号
      signArr:[0,0,0],//签到状态
      info:{
        user:{
          is_sign:0,
          is_login:1,
          coins:0,
          sign_in_day:0,
          today_bet_num:0,
        },
        sign_in_config:{
          day_one:0,
          day_two:0,
          day_three:0
        },
        today:{
          bet_num:0,
          coins:0,
          type:1,
          title:''
        }
      }
    }
  },
  methods: {
    showSignUp(num){//弹出签到成功
      this.signNum = num;
      this.signSh = true;
      const that = this;
      setTimeout(function(){
        that.signSh = false;
      },3000);
    },
    toGuess(){
      this.$router.push({'name':'List'});
    },
    toLoginFn(){
      this.gotoLogin();
    },
    toLogin(){
      this.ifLogin = false;
    },
    hideSide(){//侧边栏隐藏

      this.$refs.Model.hideSide()
    },
    toSign(){//签到
      //封号状态判断
      if(this.canBet != 1){
        this.alertTip = this.txtLang[this.curLang]['sealAccout'];
        this.$refs.Alert.show();
        return;
      }
      
      if(this.info.user.is_sign != 0){
        this.alertTip = this.txtLang[this.curLang]['signError'];
        this.$refs.Alert.show();
        return;
      }

      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.axios.post(this.getHost() + '/tasks/sign-in',qs.stringify({
            token: localStorage.getItem('guess_token'),
            lan:this.langIndex
        })
      ).then(
          (response)=>{
              var re = response.data;
              if(re.code == 200){
                  this.curCoin += parseInt(re.data.coins);
                  this.showSignUp(this.moneyStr(re.data.coins));
                  this.aniCoinShow('+' + this.moneyStr(re.data.coins));
                  this.loadTask();
              }
              else if(re.code == 401){
                this.gotoLogin();
              }
              else{
                 
              }
          }).catch((response)=>{
          console.log(response);
      });
    },
    refreshSign(){//更新签到状态

      var signDay = this.info.user.sign_in_day;//已签到天数
      var isSign = this.info.user.is_sign;//今天是否签到
      var arr = [];
      if(signDay == 0){
        arr = [1,0,0];
        if(isSign != 0){
          arr[0] = 2;
        }
      }
      else if(signDay == 1){
        arr = [2,1,0];
      }
      else if(signDay == 2){
        arr = [2,2,1];
      }
      this.signArr = arr;

    },
    refreshInfo(){//更新个人信息
      var _this = this;
      this.getUserInfo({
        success:function(e){
          //console.log(e.data.data);
          _this.curCoin = e.data.data.coins;
          _this.canBet = e.data.data.status;
          _this.noticeNum = e.data.data.notice_num;
        }
      });
    },
    loadTask(){
      var token = localStorage.getItem('guess_token') == null ? '' : '&token=' + localStorage.getItem('guess_token');
      this.axios.get(this.getHost() + '/tasks/home?lan=' + this.langIndex + token).then(
          (response)=>{
          var re = response.data;
          if(re.code == 200){
            this.info = re.data;
            this.refreshSign();
          }
          else if(re.code == 401){
            this.toLogin();
          }
          else{
            alert(re.message);
          }
      }).catch((response)=>{
        console.log(response);
      });
    },
  },
  mounted() {
    
	},
  destroyed(){
    
  },
  created(){
    //控制台查看变量
    //window.vueVar = this;
    var that = this;
    
    this.isUserLogin({
        source: this.source[this.curLang],
        platform: 2,
        success: function(data){
            if(data == 1){
                that.ifLogin = true;
                that.refreshInfo();
                
            }else{
                /*that.isLoadingShow = false;
                that.gotoLogin();
                return;*/
                that.delStorage('guess_token');
            }
            that.loadTask();
        }
    });
  }
}
</script>

<style scoped>
.signPop{position:fixed;top:0;left:0;right:0;bottom:0;z-index:500}
.signPop .s_box{width:436px;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);}
.signPop .s_box img{width:100%}
.signPop .s_box .sb_p1{position:absolute;color:#6876eb;font-size:30px;width:100%;top:60%;left:0;text-align:center}
.signPop .s_box .sb_p2{position:absolute;font-size:48px;color:#fd7446;top:70%;left:50%;font-weight:bolder;background:url('../../static/image/icon_coin_big.png') no-repeat left center;background-size:80px;padding-left:96px;padding-top:4%;padding-bottom:4%;transform:translateX(-50%);-webkit-transform:translateX(-50%);-moz-transform:translateX(-50%);-ms-transform:translateX(-50%);-o-transform:translateX(-50%);}
/*红点*/
.redPoint{position:relative}
.redPoint:after{top:-10px;right:-10px;position:absolute;display:block;content:'';background:#fb5051;width:20px;height:20px;border-radius:200px}
/*头部*/
.header{z-index:100;position:fixed;top:0;left:0;width:100%;height:120px;background:#232048;}
.header .h_title{font-size:40px;color:#fff;line-height:120px;text-align:center}
.header .h_btn{width:120px;height:120px;position:absolute;top:0;left:0}
.header .h_btn a{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%)}
.header .h_btn a img{width:28px;height:28px}
/*金币栏*/
.person{position:fixed;z-index:100;top:120px;width:100%;height:116px;background:#131229;padding-top:0}
.person .p_box{height:116px;padding:0px 55px;font-size:0;position:relative}
.person .p_box .pb_left{text-align:center;display:inline-block;margin-right:12px}
.person .p_box .pb_left img{display:block;width:40px;height:40px;margin:0 auto}
.person .p_box .pb_left p{color:#bbbabf;font-size:18px;}
.person .p_box .pb_num p{display:inline-block;font-size:30px;color:#fd7446}
.person .p_box .pb_loginBtn a{display:inline-block;border-radius:30px;min-width:150px;height:58px;text-align:center;line-height:58px;background:#6371ea;color:#fff;font-size:30px;}
.person .p_box .pb_btn{font-size:0}
.person .p_box .pb_btn a{font-size:24px;color:#6371ea;}

.body{padding:240px 22px 0px}
.body .b_box{position:relative}
.body .b_box .b_l{padding:40px 32px}
.body .b_box .b_r{position:absolute;top:56px;right:32px;width:160px;height:58px;font-size:24px;color:#fff;text-align:center;line-height:56px;border-radius:10px;background:#fd7446}
.body .b_box .b_r_on{background:#626080;color:#777690}
.body .b_list{}
.body .b_list .bl_title{font-size:30px;color:#fff;padding-bottom:24px;padding-left:32px}
.body .b_list .bl_list{}
.body .b_list .bl_list li{background:#232048;padding:40px 36px;border-radius:16px}
.body .b_list .bl_list .bl_top{padding-bottom:16px;position:relative}
.body .b_list .bl_list .bl_top p{font-size:24px;color:#bbbabf;width:80%;overflow:hidden;text-overflow: ellipsis;white-space: nowrap;}
.body .b_list .bl_list .bl_top span{position:absolute;top:0;right:0;color:#fd7446;padding-left:30px;font-size:24px;background:url('../../static/image/icon_coin.png') no-repeat left center;background-size:24px}
.body .b_list .bl_list .bl_btn{margin-left:60px}
.body .b_list .bl_list .bl_btn a{display:block;width:160px;height:58px;line-height:56px;border-radius:10px;background:#6371ea;color:#fff;text-align:center;}
.body .b_list .bl_list .bl_progress{height:16px;border-radius:10px;background:#3b3860}
.body .b_list .bl_list .bl_progress div{height:16px;border-radius:10px;background:#00d9cd}
.body .b_list .bl_list .bl_bg{background:url('../../static/image/icon_finish.png') no-repeat left center;background-size:40px}
.body .b_list .bl_list .bl_tip{color:#00d9cd;padding-left:50px;}

.signBox{font-size:0;display:inline-block;vertical-align:top;position:relative;overflow:hidden}
.signBox:after{position:absolute;display:block;content:'';width:100%;height:6px;top:44px;left:0;background:#232048}
.signBox li{display:inline-block;vertical-align:top;margin-right:94px}
.signBox li.mrN{margin-right:0px}
.signBox li .s_top{margin:4px 0;position:relative;z-index:100;width:80px;height:80px;border-radius:200px;background:#232048 url('../../static/image/icon_sign2.png') no-repeat center 80%;background-size:24px}
.signBox li .s_top .st_num{color:#fd7446;font-size:24px;text-align:center;padding-top:10px}
.signBox li .s_txt{font-size:20px;color:#3b3860;text-align:center;padding-top:4px}
.signBox li.on .s_top{background-image:url('../../static/image/icon_sign1.png')}
.signBox li.on .s_top .st_num{color:#3b3860}
.signBox li.ing .s_top{border:4px solid #fd7446}
.signBox li.ing .s_txt{color:#fd7446}
</style>












// WEBPACK FOOTER //
// src/components/task.vue